import { render, staticRenderFns } from "./certifyStandard.vue?vue&type=template&id=7de8930e"
import script from "./certifyStandard.vue?vue&type=script&lang=js"
export * from "./certifyStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports